// utils/auth.js
import config from "@/utils/config.js";
import { verifyToken as verifyTokenApi, refreshToken as refreshTokenApi } from '@/api/auth'
import Vue from 'vue'

// 登录弹窗实例
let loginDialogInstance = null
// token刷新状态
let isRefreshing = false
// token刷新队列
let refreshSubscribers = []

function getToken(showModal = false) {
  const token = sessionStorage.getItem(config.tokenKey);
  if (!token && showModal) {
    removeToken()
    return false;
  }
  return token;
}

function setToken(token) {
  return sessionStorage.setItem(config.tokenKey, token);
}

function removeToken() {
  return sessionStorage.removeItem(config.tokenKey);
}

function hasToken() {
  return !!getToken(false);
}

/**
 * 刷新token
 */
async function refreshToken() {
  if (isRefreshing) {
    // 如果正在刷新token，将请求加入队列
    return new Promise((resolve) => {
      refreshSubscribers.push(resolve);
    });
  }
  
  isRefreshing = true;
  
  try {
    const res = await refreshTokenApi();
    if (res.code === 200 && res.data && res.data.token) {
      setToken(res.data.token);
      // 通知所有等待的请求
      refreshSubscribers.forEach(cb => cb(res.data.token));
      refreshSubscribers = [];
      return res.data.token;
    }
  } catch (error) {
    console.warn('Token刷新失败');
  } finally {
    isRefreshing = false;
  }
  
  return null;
}

/**
 * 处理token过期
 */
function handleTokenExpired() {
  return refreshToken();
}

/**
 * 获取或创建登录弹窗实例
 */
function getLoginDialogInstance() {
  if (!loginDialogInstance) {
    const LoginDialog = require('@/components/LoginDialog/index.vue').default
    const LoginDialogConstructor = Vue.extend(LoginDialog)
    const store = require('@/store').default
    loginDialogInstance = new LoginDialogConstructor({ store })
    loginDialogInstance.$mount()
    document.body.appendChild(loginDialogInstance.$el)
  }
  return loginDialogInstance
}

/**
 * 显示登录弹窗
 * @returns {Promise} 登录成功返回 true，关闭弹窗返回 rejected
 */
function showLoginDialog() {
  const instance = getLoginDialogInstance()
  return instance.show()
}

/**
 * 隐藏登录弹窗
 */
function hideLoginDialog() {
  if (loginDialogInstance) {
    loginDialogInstance.hide()
  }
}

/**
 * 验证 Token 是否有效
 * @returns {Promise<boolean>} 验证结果
 */
async function verifyAuth() {
  // 先检查是否有 token
  if (!hasToken()) {
    return false
  }

  try {
    const res = await verifyTokenApi()
    return res.code === 200
  } catch (error) {
    // 不输出详细错误信息
    return true
  }
}

/**
 * 验证并拦截 - 如果验证失败则弹出登录框
 * @returns {Promise<boolean>} 验证通过返回 true，用户登录成功也返回 true
 */
async function verifyAndIntercept() {
  const isValid = await verifyAuth()

  if (isValid) {
    return true
  }

  // 验证失败，弹出登录框
  try {
    await showLoginDialog()
    return true
  } catch (error) {
    // 用户关闭了登录弹窗
    return false
  }
}

export {
  getToken,
  setToken,
  removeToken,
  hasToken,
  showLoginDialog,
  hideLoginDialog,
  verifyAuth,
  verifyAndIntercept,
  refreshToken,
  handleTokenExpired
};
